import * as React from 'react';

import classnames from 'classnames';

import {ChevronLeftIcon, ChevronRightIcon} from '../icon';

import styles from './pagination-controls.module.css';

type PaginationControlsProps = {
    onPageChange: (arg1: number) => any;
    selectedPage: number;
    totalPages: number;
    displayPageControls?: boolean;
    hasFlexGrow?: boolean;
    disableButtons?: boolean;
    disableNextButton?: boolean;
};

export class PaginationControls extends React.Component<PaginationControlsProps> {
    static defaultProps = {
        displayPageControls: true,
        hasFlexGrow: true,
    };

    render() {
        const className = this.props.hasFlexGrow ? 'flex-grow' : '';

        return (
            <div className={classnames(className, styles.container)}>
                <button
                    disabled={this.props.disableButtons || !this.canSelectPreviousPage()}
                    onClick={this.handlePrevClick}
                    className={
                        this.canSelectPreviousPage() ? styles.control : styles['control-disabled']
                    }
                >
                    <ChevronLeftIcon className={styles.chevron} />
                    <span className={styles.prev}>Prev</span>
                </button>
                {this.props.displayPageControls ? this.renderPageControls() : null}
                <button
                    disabled={
                        this.props.disableButtons ||
                        this.props.disableNextButton ||
                        !this.canSelectNextPage()
                    }
                    onClick={this.handleNextClick}
                    className={
                        this.canSelectNextPage() ? styles.control : styles['control-disabled']
                    }
                >
                    <span className={styles.next}>Next</span>
                    <ChevronRightIcon className={styles.chevron} />
                </button>
            </div>
        );
    }

    renderPageControls() {
        const possiblePages = Array(this.props.totalPages)
            .fill(1)
            .map((val, index) => {
                const realPageNum = index + 1;

                return realPageNum === this.props.selectedPage ? (
                    <button key={realPageNum} className={styles['page-control-selected']}>
                        {realPageNum}
                    </button>
                ) : (
                    <button
                        key={realPageNum}
                        onClick={() => this.handlePageChange(realPageNum)}
                        className={styles['page-control']}
                    >
                        {realPageNum}
                    </button>
                );
            });

        let firstPageIndex = 0;
        let lastPageIndex = 5;

        if (this.props.totalPages > 5) {
            firstPageIndex =
                this.props.selectedPage < 4
                    ? 0
                    : Math.min(this.props.selectedPage - 3, this.props.totalPages - 5);

            lastPageIndex =
                this.props.totalPages - this.props.selectedPage > 1
                    ? Math.max(this.props.selectedPage + 2, 5)
                    : this.props.totalPages;
        }

        return (
            <div className={styles['page-controls']}>
                {possiblePages.slice(firstPageIndex, lastPageIndex)}
            </div>
        );
    }

    handlePrevClick = () => {
        if (this.canSelectPreviousPage()) {
            this.handlePageChange(this.props.selectedPage - 1);
        }
    };

    handleNextClick = () => {
        if (this.canSelectNextPage()) {
            this.handlePageChange(this.props.selectedPage + 1);
        }
    };

    handlePageChange = (newPageNum: number) => {
        this.props.onPageChange(newPageNum);
    };

    canSelectPreviousPage = () => {
        return this.props.selectedPage > 1;
    };

    canSelectNextPage = () => {
        return this.props.selectedPage < this.props.totalPages;
    };
}
